var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleDriveIntIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_903_1360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.49992 17.141L3.4871 18.8462C3.69223 19.2051 3.9871 19.4872 4.33326 19.6923L7.8589 13.5898H0.807617C0.807617 13.9872 0.910181 14.3846 1.11531 14.7436L2.49992 17.141Z",
    fill: "#0066DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 6.41024L8.47428 0.307678C8.12813 0.512806 7.83326 0.794858 7.62813 1.15383L1.11531 12.4359C0.913954 12.7871 0.807885 13.1849 0.807617 13.5897H7.8589L11.9999 6.41024Z",
    fill: "#00AC47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6665 19.6923C20.0127 19.4872 20.3076 19.2051 20.5127 18.8462L20.9229 18.141L22.8845 14.7436C23.0896 14.3846 23.1922 13.9872 23.1922 13.5898H16.1404L17.6409 16.5385L19.6665 19.6923Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 6.41026L15.5256 0.307692C15.1795 0.102564 14.7821 0 14.3718 0H9.62821C9.21796 0 8.82052 0.115385 8.47437 0.307692L12 6.41026Z",
    fill: "#00832D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1409 13.5898H7.85889L4.33325 19.6923C4.67941 19.8974 5.07684 20 5.4871 20H18.5127C18.923 20 19.3204 19.8846 19.6666 19.6923L16.1409 13.5898Z",
    fill: "#2684FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6282 6.79486L16.3718 1.15383C16.1667 0.794858 15.8718 0.512806 15.5256 0.307678L12 6.41024L16.141 13.5897H23.1795C23.1795 13.1923 23.0769 12.7949 22.8718 12.4359L19.6282 6.79486Z",
    fill: "#FFBA00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_903_1360"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.3846,
    height: 20,
    fill: "white",
    transform: "translate(0.807617)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleDriveIntIcon);
export default __webpack_public_path__ + "static/media/GoogleDriveIntIcon.23644259f4a4f9044502bc3c2579898c.svg";
export { ForwardRef as ReactComponent };